import React, { useState, useEffect } from "react";
import { Button, Alert } from "react-bootstrap";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { VpnKey } from "@material-ui/icons";
import * as message from "../../config/CommonMessages";
import InputMask from "react-input-mask";
import { useParams } from "react-router-dom";
import UrlConstants from "../../config/UrlConstants";
import axios from "axios";
import * as code from "./../../config/Constants";
import { toastMessage } from "../Common/Common";
import { useHistory, Link } from "react-router-dom";
import {
  forgotPasswordAction,
  NewforgotPasswordAction,
  forgotUserNameNew,
} from "./../../actions/UserActions";
import { connect } from "react-redux";

function SetpasswordAuthenticationNew(props) {
  const [contact, setContacts] = useState({
    email: "",
    mobileNumber: "",
  });
  const [showLoader, setShowLoader] = React.useState(false);

  const [radioInput, setRadioInput] = React.useState("email");
  const [contactNotfound, setContactNotfound] = React.useState(false);
  const [setLinksand, setSetLinksand] = React.useState(false);
  const [userNotauthorized, setUserNotauthorized] = React.useState(false);

  const handleChange = (event) => {
    // console.log("event======>", event.target.name);

    // use spread operator
    if (event.target.name == "mobileNumber") {
      setContacts({
        ...contact,
        [event.target.name]: event.target.value.replace(/-/g, ""),
      });
    } else {
      setContacts({
        ...contact,
        [event.target.name]: event.target.value,
      });
    }
  };

  const onRadioChange = (e) => {
    let name = e.target.value;
    if (name == "mobileNumber") {
      setContacts({
        ...contact,
        ["email"]: "",
      });
    } else if (name == "email") {
      setContacts({
        ...contact,
        ["mobileNumber"]: "",
      });
    }
    // console.log("name", name);

    setRadioInput(e.target.value);
  };
  const forgotuserNameAction = (data) => {
    // setShowLoader(true);
    // console.log("i am here", data);
    setContactNotfound(false);
    setUserNotauthorized(false);
    setSetLinksand(false);
    setShowLoader(true);

    props
      .forgotUserNameNew(data)
      .then((res) => {
        // console.log("res===========>", res);
        if (res.status === code.OK) {
          if (res.data.error == 404) {
            // user not exists
            setContactNotfound(true);
          } else if (res.data.error == 403) {
            // user exists but not authorized .
            setUserNotauthorized(true);
          } else {
            // sucess
            setSetLinksand(true);
          }
        }
        setShowLoader(false);
      })
      .catch((e) => {
        console.log("error", e);
      });
  };

  return (
    <div>
      {showLoader ? (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : setLinksand ? (
        <div className="loginBg loginContent align-items-start flex-column">
          <div className="loginBox">
            <div className="message-log-before mb-3">
              <h4 className="mb-3">Forgot username request received</h4>
              <p className="font-14 color-grey-1 font-400">
                You will receive your username to your respected contact.
              </p>
              <Link style={{ color: "white" }} to="/login">
                <Button
                  variant="primary"
                  className="btn-blue btn-medium btn btn-block btn-lg"
                >
                  Login
                </Button>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div className="loginBg loginContent align-items-end flex-column">
          <div className="loginBox">
            <div>
              <h4>Forgot Username?</h4>
              <Formik
                validateOnChange={true}
                validateOnBlur={true}
                initialValues={contact}
                enableReinitialize={true}
                validationSchema={Yup.object().shape(
                  {
                    email: Yup.string().when("mobileNumber", {
                      is: (mobileNumber) =>
                        !mobileNumber || mobileNumber.length === 0,
                      then: Yup.string()
                        .trim()
                        .email(message.ENTER_VALID_EMAIL)
                        .required("This field is required"),
                    }),
                    mobileNumber: Yup.string().when("email", {
                      is: (email) => !email || email.length === 0,
                      then: Yup.string()
                        .nullable()
                        .required("This field is required")
                        .test(
                          "mobileNumber",
                          message.ENTER_VALID_MOBILE,
                          (value) => {
                            if ((value || "").length === 10 && value.charAt(0) != "0") {
                              return true;
                            }
                            return false;
                          }
                        ),
                    }),
                  },
                  ["email", "mobileNumber"]
                )}
                onSubmit={(values) => {
                  forgotuserNameAction(values);
                  // console.log("values", values);
                }}
              >
                {({ errors, values, touched }) => (
                  <Form>
                    <div className="form-group">
                      <div className="row">
                        <div
                          className="col-md-3 col-sm-6"
                          style={{ flex: "none", width: "auto" }}
                        >
                          <input
                            type="radio"
                            value="email"
                            name="name123"
                            checked={radioInput === "email"}
                            onChange={onRadioChange}
                          />{" "}
                          Email
                        </div>
                        <div
                          className="col-md-6 col-sm-6 p-0"
                          style={{ flex: "none", width: "auto" }}
                        >
                          <input
                            type="radio"
                            value="mobileNumber"
                            name="name123"
                            checked={radioInput === "mobileNumber"}
                            onChange={onRadioChange}
                          />{" "}
                          Mobile Number
                        </div>
                      </div>
                    </div>
                    <div className="icon-wrapper input-group">
                      <Field
                        type="text"
                        name="email"
                        onChange={handleChange}
                        value={values.email}
                        className={
                          "form-control form-control-lg" +
                          (errors.email && touched.email ? " is-invalid" : "")
                        }
                        style={{
                          display: radioInput === "mobileNumber" ? "none" : "",
                        }}
                      />
                      <InputMask
                        mask="999-999-9999"
                        maskChar=""
                        formcontrolprops={{
                          fullWidth: true,
                        }}
                        value={values.mobileNumber}
                        className={
                          "form-control form-control-lg" +
                          (errors.mobileNumber && touched.mobileNumber
                            ? " is-invalid"
                            : "")
                        }
                        name="mobileNumber"
                        onChange={handleChange}
                        style={{
                          display: radioInput === "email" ? "none" : "",
                        }}
                      />
                    </div>

                    {errors.email && touched.email && !errors.mobileNumber ? (
                      <div style={{ color: "white" }}>{errors.email}</div>
                    ) : errors.email && !errors.mobileNumber ? (
                      <div style={{ color: "white" }}>{errors.email}</div>
                    ) : null}

                    {errors.mobileNumber && touched.mobileNumber ? (
                      <div style={{ color: "white" }}>{errors.mobileNumber}</div>
                    ) : errors.mobileNumber ? (
                      <div style={{ color: "white" }}>{errors.mobileNumber}</div>
                    ) : null}
                    {contactNotfound ? (
                      <div style={{ color: "white" }}>
                        Your contact is not found
                      </div>
                    ) : (
                      ""
                    )}
                    {userNotauthorized ? (
                      <div style={{ color: "white" }}>
                        You are unauthorized user.
                      </div>
                    ) : (
                      ""
                    )}
                    <p className="font-14 color-grey-1 font-300 mt-1">
                      Enter the contact associated with your account.
                    </p>
                    <div className="form-group pt-2">
                      <Button
                        type="submit"
                        variant="primary"
                        size="lg"
                        block
                        className="btn-blue btn-medium"
                      >
                        Submit
                      </Button>
                    </div>
                    <div className="form-group pt-4 text-center mb-0">
                      <span className="font-14 color-grey-1 font-300">
                        Remember Password?
                      </span>{" "}
                      <Link style={{ color: "white" }} to="/login">
                        Login
                      </Link>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    forgotdata: state.reducer.forgotdata,
    forgotsuccess: state.reducer.forgotsuccess,
  };
};

export default connect(
  mapStateToProps,
  {
    forgotPasswordAction,
    NewforgotPasswordAction,
    forgotUserNameNew,
  }
)(SetpasswordAuthenticationNew);
